import { axiosInstance as apiClient } from "@/config/apiClient";
import type { UserProfileResponse, ProfileFormData } from "../schemas";

/**
 * Get user profile from backend
 */
export async function getProfile(): Promise<UserProfileResponse> {
	const response = await apiClient.get<UserProfileResponse>("/profile");
	return response.data;
}

/**
 * Update user profile
 */
export async function updateProfile(
	data: Partial<ProfileFormData>,
): Promise<UserProfileResponse> {
	const response = await apiClient.patch<UserProfileResponse>("/profile", data);
	return response.data;
}

/**
 * Upload avatar image
 * Note: This is a placeholder - implement based on your backend upload strategy
 */
export async function uploadAvatar(file: File): Promise<{ url: string }> {
	const formData = new FormData();
	formData.append("file", file);

	const response = await apiClient.post<{ url: string }>(
		"/profile/avatar",
		formData,
		{
			headers: {
				"Content-Type": "multipart/form-data",
			},
		},
	);

	return response.data;
}
